import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import moment from'moment-timezone';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TiretPipe } from 'src/app/pipe/tiret.pipe';
import { GroupeFormationModel } from 'src/models/groupe-formation/groupe-formation-model';
import { GroupeFormationService } from 'src/services/groupe-formation.service';
import { AjouterModifierFormationGroupeDialogComponent } from './ajouter-modier-formation-groupe-dialog/ajouter-modifier-formation-groupe-dialog.component';
import { ShowParticipantDialogComponent } from './show-participant-dialog/show-participant-dialog.component';
import { ScormPackageLocaleModel, ScormPackageModel } from 'src/models/scormPackageModel';
import { ScormService } from 'src/services/scorm.service';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { CustomPaginatorIntlService } from 'src/services/custom-paginator-intl.service';
import { StringHelpers } from 'src/models/helpers/string-helpers';
import { MatMenuModule } from '@angular/material/menu';
import { ConfirmationExportDialogComponent } from '../../../commun/dialog/confirmation-export-dialog/confirmation-export-dialog.component';

@Component({
    selector: 'app-groupes-formation-managment',
    templateUrl: './groupes-formation-managment.component.html',
    styleUrls: ['./groupes-formation-managment.component.scss'],
    imports: [
        MatIconModule,
        CommonModule,
        MatProgressSpinnerModule,
        TranslateModule,
        MatSnackBarModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatTableModule,
        MatPaginator,
        MatSortModule,
        MatButtonModule,
        TiretPipe,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDateModule,
        MatMenuModule
    ],
    providers: [
        {
            provide: MatPaginatorIntl,
            useClass: CustomPaginatorIntlService
        }
    ]
})
export class GroupesFormationManagmentComponent implements OnInit, AfterViewInit {
  moment = moment;
  dateDebut: Date = moment().startOf('month').toDate();
  dateFin: Date = moment().endOf('month').toDate();
  isLoading: boolean = false;
  filter: 'complete' | 'plannifier' = 'plannifier';
  hasData: boolean = false;
  formations: GroupeFormationModel[] = [];
  tousLesFormations: GroupeFormationModel[] = [];
  formationsAfficher: GroupeFormationModel[] = [];
  formationsFiltreEncours: GroupeFormationModel[] = [];
  scormPackages: ScormPackageModel[] = [];

  pageIndex: number = 0;
  pageSize: number = 10;
  currentPage: number = 0;
  totalItems: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  selectionDateAcces: string = "";
  selectionTitreContenu: string = "";
  formationsSelection: string[] = [];

  titres: string[] = [];
  titreFilterCtrl: FormControl = new FormControl();
  filteredTitres: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);


  textFilter: string = '';
  isFiltering: boolean = false;
  textRechercher: string = "";

  dataSource!: MatTableDataSource<GroupeFormationModel>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = [
    'id',
    'titre',
    'titreContenu',
    'emplacement',
    'datePrevue',
    'prenomNomAjoutUtilisateurPar',
    'superviseurs',
    'nombreParticipants',
    'commentaire',
    'actions'
  ];

  _onDestroy = new Subject<void>();
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private groupeFormationService: GroupeFormationService,
    private utilisateurService: UtilisateurService,
    public scormService: ScormService,
    private dialog: MatDialog,
    public translate: TranslateService
  ) {
    this.dataSource = new MatTableDataSource<GroupeFormationModel>([]);
  }

  ngOnInit() {
    this.obtenirFormationsGroupe();
    this.bindFiltredCtl();
  }
  setFilter(newFilter: 'complete' | 'plannifier'): void {
    this.filter = newFilter;
    this.isLoading = true;
    this.filtreFormation();
    this.ajusterColonnesTableSelonPage();
  }

  private bindFiltredCtl() {
    this.titreFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtredTitre();
      });
  }

  private filtredTitre() {
    if (!this.titres) {
      return;
    }
    let search = this.titreFilterCtrl.value;
    if (!search) {
      this.filteredTitres.next(this.titres.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredTitres.next(
      this.titres.filter(titre => titre.toLowerCase().indexOf(search) > -1)
    );
  }

  filtreFormation() {
    if (this.filter === 'complete') {
      this.formations = this.tousLesFormations.filter((formation) => formation.dateCompletee !== null);

    } else if (this.filter === 'plannifier') {
      this.formations = this.tousLesFormations.filter((formation) => formation.dateCompletee === null);
    }
    this.formationsFiltreEncours = this.formations;
    this.totalItems = this.formationsFiltreEncours.length;
    this.pageIndex = 0;
    this.paginer();
    this.isLoading = false;
    this.hasData = false;
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }
  }


  loadScormPackages() {
    this.isLoading = true;
    this.scormService.getAllPackages(this.utilisateurService.entiteUtilisateurSelectionnee.entiteId).subscribe(res => {
      this.scormPackages = res;
      this.isLoading = false;
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.totalItems = this.formations.length;
      this.refreshDataSource();
    }
  }

   get estPageComplete(): boolean {
      return this.filter === 'complete';
  }

   ajusterColonnesTableSelonPage() {
    const indexDateComplete = this.displayedColumns.indexOf('dateCompletee');
    if (this.estPageComplete) {
      if (indexDateComplete === -1) {
        this.displayedColumns.splice(5, 0, 'dateCompletee');
      }
    } else {
      if (indexDateComplete !== -1) {
        this.displayedColumns.splice(indexDateComplete, 1);
      }
    }
  }

  get codeLangue(): string {
    return this.translate.currentLang;
  }

  toggleMenu(index: number): void {
    this.formationsFiltreEncours.forEach((tag, i) => {
      tag.isMenuOpen = (i === index) ? !tag.isMenuOpen : false;
    });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const isInsideMenu = target.closest('.menu-container');
    if (!isInsideMenu) {
      this.formationsFiltreEncours.forEach(tag => tag.isMenuOpen = false);
    }
  }


  paginer(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.formationsAfficher = this.formationsFiltreEncours.slice(startIndex, endIndex);
    this.dataSource.data = this.formationsAfficher;
    this.changeDetectorRef.detectChanges();
  }


    sortDataChange(sortState: Sort) {
      if (sortState.direction) {
          this.dataSource.sortingDataAccessor = (item: any, property: string) => {
            const value = item[property];

            return typeof value === 'string' ? StringHelpers.removeDiacritics(value) : value;
          };
          this.dataSource.sort = this.sort;
      }
    }

  showParticipants(formationGroupe: GroupeFormationModel): void {
    const dialogRef = this.dialog.open(ShowParticipantDialogComponent, {
      width: '33.33vw',
      disableClose: true,
      data: formationGroupe
    });
  }

  filtreTitreContenus(): void {
    if (this.selectionTitreContenu != "") {
      this.formationsSelection = this.selectionTitreContenu.toString().split(",");
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenus => this.formationsSelection.some(e => e === contenus.titre));
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else {
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    }
  }

  filtreDateAcces(): void {
    if (this.selectionDateAcces == 'alldate') {
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else if (this.selectionDateAcces == 'today') {
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenu => moment(contenu.dateHeurePrevue).local().isSame(moment(), 'day'));
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else if (this.selectionDateAcces == 'yesterday') {
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenu => moment(contenu.dateHeurePrevue).local().isSame(moment().subtract(1, 'days'), 'day'));
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else if (this.selectionDateAcces == 'week') {
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenu => moment(contenu.dateHeurePrevue).local().isSame(moment(), 'week'));
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else if (this.selectionDateAcces == 'lastweek') {
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenu => moment(contenu.dateHeurePrevue).local().isSame(moment().subtract(1, 'weeks'), 'week'));
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else if (this.selectionDateAcces == 'last30days') {
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenu => moment(contenu.dateHeurePrevue).local().isBetween(moment().subtract(29, 'days').startOf('day'), moment().endOf('day'), undefined, '[]'));
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else if (this.selectionDateAcces == 'lastmonth') {
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenu => moment(contenu.dateHeurePrevue).local().isSame(moment().subtract(1, 'months'), 'month'));
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else if (this.selectionDateAcces == 'year') {
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenu => moment(contenu.dateHeurePrevue).local().year() === moment().year());
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else if (this.selectionDateAcces == 'lastyear') {
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenu => moment(contenu.dateHeurePrevue).local().year() === moment().subtract(1, 'years').year());
      this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
    } else if (this.selectionDateAcces == 'custom') {
      if (this.dateDebut && this.dateFin) {
        this.formationsFiltreEncours = this.formationsFiltreEncours.filter(contenu => moment(contenu.dateHeurePrevue).local().isBetween(moment(this.dateDebut).local().toDate(), moment(this.dateFin).local().toDate()));
        this.dataSource = new MatTableDataSource(this.formationsFiltreEncours);
      }
    }
  }


  filtreRecherche(): void {
    if (this.textRechercher && this.textRechercher.length > 2) {
      const textRechercher = this.textRechercher.trim().toLowerCase();
      this.formationsFiltreEncours = this.formationsFiltreEncours.filter(event => {
        const checkValue = (value: any): boolean => {
          if (value && typeof value === 'object') {
            return Object.values(value).some(v => checkValue(v));
          }
          return value && String(value).toLowerCase().includes(textRechercher);
        };

        return Object.values(event).some(value => checkValue(value));
      });
    }
  }

  nombreParticipants(id: number): number | null {
    return this.formations.find(f => f.id === id)?.utilisateurs.length || null;
  }

  filtre(): void {
    if (this.isFiltering) return;
    this.isFiltering = true;

    try {
      this.applyFilters();

    } finally {
      this.isFiltering = false;
    }
  }

  private applyFilters(): void {
    this.formationsFiltreEncours = this.formations;
    this.filtreTitreContenus();
    this.filtreDateAcces();
    this.filtreRecherche();
    this.totalItems = this.formationsFiltreEncours.length;
    this.dataSource = new MatTableDataSource<GroupeFormationModel>(this.formationsFiltreEncours);
    this.paginer();
  }

  reinitialiserFiltre(): void {
    this.textRechercher = "";
    this.applyFilters();
  }
  private updatePaginatorLength(): void {
    if (this.paginator) {
      this.paginator.length = this.formationsFiltreEncours.length;
      this.totalItems = this.formationsFiltreEncours.length;
      this.paginator.page.emit();
      this.changeDetectorRef.detectChanges();
    }
  }

  refreshDataSource(): void {
    this.formationsFiltreEncours = this.formations;
    this.dataSource = new MatTableDataSource<GroupeFormationModel>(this.formationsFiltreEncours);
    this.updatePaginatorLength();
  }

  getLocalizedContent(scormPackageId: number): ScormPackageLocaleModel {
    const locales = this.scormPackages.find(scorm => scorm.scormPackageId === scormPackageId)!.locales;
    const currentLang = this.translate.currentLang || 'fr';
    return locales.find(locale => locale.langue.toLowerCase() === currentLang) || locales[0];
  }


  private obtenirFormationsGroupe(): void {
    this.isLoading = true;
    this.groupeFormationService.ObtenirGroupeFormations().subscribe(formations => {
      this.tousLesFormations = formations;
      this.formations = this.tousLesFormations.filter(f => f.dateCompletee === null);
      this.loadScormPackages();
      this.mapperFiltres(this.formations);
      this.applyFilters();
    });
  }


  private mapperFiltres(formations: GroupeFormationModel[]) {
    this.titres = [...new Set(formations.map(contenu => contenu.titre))]
      .sort((a, b) => (a ?? '').localeCompare(b ?? '', 'fr', { sensitivity: 'base' }));
    this.filteredTitres.next(this.titres);
  }

  editTrainning(formationGroupe: GroupeFormationModel): void {
    const dialogRef = this.dialog.open(AjouterModifierFormationGroupeDialogComponent, {
      width: '90vw',
      height: '90vh',
      disableClose: true,
      data: formationGroupe
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
        this.obtenirFormationsGroupe();
    });
  }

  withdrawTrainning(id: number): void {
    this.isLoading = true;
    this.groupeFormationService.SupprimerFormationGroupe(id).subscribe(() => {
      this.obtenirFormationsGroupe();
      this.isLoading = false;
    });
  }

  openCreateGroupTrainingDialog(): void {
    const dialogRef = this.dialog.open(AjouterModifierFormationGroupeDialogComponent, {
      width: '66.66vw',
      disableClose: true,
      data: null
    });
    dialogRef.afterClosed().subscribe((result: GroupeFormationModel) => {
      if (result != null) {
        this.obtenirFormationsGroupe();
      }
    });
  }

  exporterVersExcel(): void {
    const ids = this.formationsFiltreEncours.map(c => c.id);
    if (!ids.length) return;
    const dialogRef = this.dialog.open(ConfirmationExportDialogComponent, {
      width: '600px',
      data: { exportLabelKey: 'GROUP_TRAINING_MANAGEMENT.EXPORT_EXCEL' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        const codeLangue = this.translate.currentLang || 'fr';
        this.groupeFormationService.exporterFormations(ids, codeLangue).subscribe(blob => {
          const now = new Date();
          const pad = (n: number) => n.toString().padStart(2, '0');
          const datetime = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
          const filename = `formations_groupe_${datetime}.xlsx`;
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.isLoading = false;
        }, () => {
          this.isLoading = false;
        });
      }
    });
  }

  exporterVersPdf(): void {
    const ids = this.formationsFiltreEncours.map(c => c.id);
    if (!ids.length) return;
    const dialogRef = this.dialog.open(ConfirmationExportDialogComponent, {
      width: '600px',
      data: { exportLabelKey: 'GROUP_TRAINING_MANAGEMENT.EXPORT_PDF' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        const codeLangue = this.translate.currentLang || 'fr';
        this.groupeFormationService.exporterFormationsPdf(ids, codeLangue).subscribe(blob => {
          const now = new Date();
          const pad = (n: number) => n.toString().padStart(2, '0');
          const datetime = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
          const filename = `formations_groupe_${datetime}.pdf`;
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.isLoading = false;
        }, () => {
          this.isLoading = false;
        });
      }
    });
  }
}
